import React from 'react'
import Button from './index'
import { Typography, Box } from '@mui/material'
import { Icon } from 'packages/eid-icons'

const styles = {
    normal: {
        width: '140px',
        height: '40px',
        backgroundColor: '#ffffff',
        color: '#363636',
        border: 'solid 1px #d2d2d9',

        '& >span': { display: 'flex', flexDirection: 'column' },
        '&:hover': {
            backgroundColor: '#ffffff',
            opacity: 0.95,
        },
        '&:active': {
            backgroundColor: '#ffffff',
        },
    },
    disabled: {
        backgroundColor: '#aab0b4 !important',
        color: '#ffffff !important',
    },

    label: {
        fontSize: '14px',
        fontWeight: 'bold',
        lineHeight: 1.15,
    },
    subLabel: {
        fontSize: '11px',
        color: '#8b909a',
        lineHeight: 1.15,
    },
}

const EndIcon = ({ order }) => {
    return (
        <Icon
            name="ArrowLong"
            width="16px"
            height="16px"
            color="#0057A0"
            direction={order === 'asc' ? 'down' : 'up'}
        />
    )
}

const SortButton = ({ children, label, subLabel, order, ...rest }) => {
    return (
        <Button
            style={styles.normal}
            size="medium"
            disabledStyles={styles.disabled}
            endIcon={order ? <EndIcon order={order} /> : null}
            {...rest}
        >
            {!children ? (
                <Box style={{ display: 'flex' }}>
                    <Box>
                        <Typography style={styles.label}>{label}</Typography>

                        <Typography style={styles.subLabel}>
                            {subLabel}
                        </Typography>
                    </Box>
                </Box>
            ) : (
                children
            )}
        </Button>
    )
}

export default SortButton
